import { render, staticRenderFns } from "./extensionTimeCell.vue?vue&type=template&id=afefcc4c&scoped=true"
import script from "./extensionTimeCell.vue?vue&type=script&lang=js"
export * from "./extensionTimeCell.vue?vue&type=script&lang=js"
import style0 from "./extensionTimeCell.vue?vue&type=style&index=0&id=afefcc4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afefcc4c",
  null
  
)

export default component.exports